// extracted by mini-css-extract-plugin
module.exports = {"api-key-form":"ApiKeyForm_api-key-form__1HNn5","api-key-form-mobile":"ApiKeyForm_api-key-form-mobile__15e03"};